import { render, staticRenderFns } from "./LevelResult.vue?vue&type=template&id=52c86cd0&scoped=true&"
import script from "./LevelResult.vue?vue&type=script&lang=js&"
export * from "./LevelResult.vue?vue&type=script&lang=js&"
import style0 from "./LevelResult.vue?vue&type=style&index=0&id=52c86cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c86cd0",
  null
  
)

component.options.__file = "LevelResult.vue"
export default component.exports